import type { ProfileState } from '@/vuex-store/profile/ProfileState.interface';

export default {
  setCurrentTab(state: ProfileState, currentTab: string) {
    state.currentTab = currentTab;
  },
};
